<template lang="pug">
  #MapBuilder
    WtTitle(card-title) Create A Custom Template For Wellness Challenges
    BField(
      label="Name"
    )
      BInput(
        name="name"
        v-model="mapName"
      )
    BField(label="Upload Template Image")
      WtUploadImage(
        entity="map"
        :imageSize="'1000 x 1000'"
        @updateImage="mapImage = $event"
      )
    BField(
      label="Description"
    )
      WtWysiwyg#mapDescription(
        selector="#mapDescription"
        :content.sync="mapDescription"
      )
    BField(
      label="Metrics"
    )
      WtSwitchQuestionInput(
        v-for="(metricValue, metricName) in metrics"
        :key="metricName"
        v-model="formDataMetrics[metricName]"
        :label="getLabel(metricName)"
        :tooltip-text="metricValue + ' points.'"
        :name="'enable ' + formDataMetrics[metricName]"
        :false-value="0"
        :true-value="metricValue"
        true-value-text="On"
        false-value-text="Off"
      )
    BField
      BMessage(
        v-if="submitError"
        type="is-danger"
        has-icon
      ) {{ submitError }}

      .level
        .level-left
        .level-right
          .level-item
            WtRouterLink(
              to="ChallengeCenter"
            ) Cancel
          .level-item
            WtButton(
              @click.native="submit"
            ) Save
</template>

<script>
import { mapActions } from "vuex";
import { stringToBase64 } from "@/base64Helper";
import WtRouterLink from "@@/WtRouterLink/WtRouterLink";
import WtButton from "@@/WtButton/WtButton";
import UniquenessCheck from "@@/WtUniquenessCheckInput/WtUniquenessCheckInput";
import WtTile from "@@/WtTile/WtTile";
import WtTitle from "@@/WtTitle/WtTitle";
import WtLabel from "@@/WtLabel/WtLabel";
import WtWysiwyg from "@@/WtWysiwyg/WtWysiwyg";
import WtUploadImage from "@@/WtUploadImage/WtUploadImage";
import WtSwitchQuestionInput from "@@/WtSwitchQuestionInput/WtSwitchQuestionInput";

export default {
  name: "CustomWellnessTemplateBuilder",

  components: {
    WtButton,
    WtRouterLink,
    UniquenessCheck,
    WtTile,
    WtTitle,
    WtWysiwyg,
    WtUploadImage,
    WtLabel,
    WtSwitchQuestionInput
  },

  data() {
    return {
      metrics: null,
      formDataMetrics: null,
      submitError: "",
      submitLoading: false,
      metricsLoading: false,
      mapName: "Custom Wellness Map",
      mapDescription: "",
      mapImage: null
    };
  },

  computed: {
    formDataMetricsPayload() {
      return this._.pickBy(this.formDataMetrics, metricValue => !!metricValue);
    }
  },

  async mounted() {
    await this.getMetrics();
  },

  methods: {
    ...mapActions(["snackBar"]),
    ...mapActions("program", ["fetchProgramMaps"]),

    async submit() {
      this.submitLoading = true;
      this.submitError = false;

      let formDataPayload = new FormData();
      formDataPayload.set("programId", this.$auth.user().programId);
      formDataPayload.set("name", this.mapName);
      formDataPayload.set("description", stringToBase64(this.mapDescription));
      if (this.mapImage) {
        formDataPayload.set("image", this.mapImage);
      }
      Object.keys(this.formDataMetricsPayload).forEach(metric => {
        formDataPayload.set(
          `metrics[${metric}]`,
          this.formDataMetricsPayload[metric]
        );
      });

      try {
        await this.axios.post(
          `maps/store-wellness-map-for-program`,
          formDataPayload
        );
        this.snackBar({
          type: "is-success",
          message: `Template Saved!`
        });
        // refresh the maps that show in the challenge builder
        this.fetchProgramMaps();
        this.$router.push({ name: "ChallengeCenter" });
      } catch (error) {
        this.snackBar({
          type: "is-danger",
          message: `There was an error. Please try again or reach out to wellness@be-engaged.co.`
        });
        this.submitError = this._.get(
          error,
          "response.data.error.message",
          "There was an error. Please try again or reach out to wellness@be-engaged.co."
        );
      }
      this.submitLoading = false;
    },

    async getMetrics() {
      try {
        this.metricsLoading = true;
        let response = await this.axios.get(
          `programs/${this.$auth.user().programId}/wellness-metrics`
        );
        this.metrics = Object.assign({}, response.data.data);
        this.formDataMetrics = Object.assign({}, response.data.data);
      } catch (error) {
        this.metrics = null;
      }
      this.metricsLoading = false;
    },
    getLabel(metricName) {
      if (metricName === "posting") {
        return "Steps";
      } else if (metricName === "textandimage") {
        return "Journal Entry and Photo";
      } else {
        return metricName.charAt(0).toUpperCase() + metricName.slice(1);
      }
    }
  }
};
</script>

<style lang="sass" scoped></style>
